export default __webpack_public_path__ + "static/media/carousel-img-3.255f2e9c.webp";